import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { MemberUserEffects } from './member-user.effects';
import { memberUserReducer } from './member-user.reducer';

export const provideMemberUserStore = () => [
  provideState('memberUsers', memberUserReducer),
  provideEffects([MemberUserEffects]),
];
